/**
 * 📊 XLSX CONTROLLER
 * Location: src/registered/common/parsers/XlsxController.js
 */
import * as XLSX from 'xlsx';
import { TaxonomyReconstructor } from '../../site-admin/components/Workflow-esg/services/taxonomy_reconstructor';

export const XlsxController = {
    /**
     * Entry point for XLSX taxonomy files.
     * Resolves workbook sheets and delegates reconstruction to the Service.
     */
    execute: async (buffer, onProgress) => {
        try {
            const workbook = XLSX.read(new Uint8Array(buffer), { type: 'array' });

            // 1. Resolve Mapping from Environment
            const mapping = {
                presentation: process.env.REACT_APP_ESG_PRESENTATION,
                definition: process.env.REACT_APP_ESG_DEFINITION,
                calculation: process.env.REACT_APP_ESG_CALCULATION
            };

            /**
             * Internal helper to validate and extract raw sheet data
             */
            const getSheet = (name) => {
                if (!name) throw new Error("Target sheet name is undefined in environment.");
                const sheet = workbook.Sheets[name];
                if (!sheet) throw new Error(`Sheet "${name}" not found in Excel file.`);

                const rawRows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "" });
                const colMap = {};
                
                // Construct column index map from the header row
                (rawRows[0] || []).forEach((text, index) => {
                    if (text) colMap[String(text).trim()] = index;
                });
                
                return { rows: rawRows, colMap };
            };

            // 2. Extract Data Pillars
            const presData = getSheet(mapping.presentation);
            const defData  = getSheet(mapping.definition);
            const calcData = getSheet(mapping.calculation);

            // 🚀 3. THE CALL: Single source of truth for reconstruction
            const result = TaxonomyReconstructor.reconstruct(presData, defData, calcData);

            // 4. Return integrated payload to DiscoveryFactory
            return { 
                format: 'XLSX_TAXONOMY', 
                esgTree: result.esgTree,
                xbrlRelationships: result.xbrlRelationships 
            };

        } catch (err) {
            console.error("❌ [XLSX_CONTROLLER_ERROR]:", err.message);
            if (onProgress) onProgress({ status: 'FAIL', label: `Mapping Error: ${err.message}` });
            throw err;
        }
    }
};